import moment from 'moment-timezone';

function getDateToDisplay(dateString: string, timezone?: string) {
  const date = moment.utc(dateString);
  if (date.toISOString() === date.startOf('day').toISOString()) {
    return date;
  }
  const _timezone = timezone || moment.tz.guess();
  return moment.tz(dateString, _timezone);
}

export default getDateToDisplay;
